import { SearchQueryParams } from "../search.types";

export const mapSearchTermToQuery = (searchTerm: string) => {
    return searchTerm?.length > 0 ? `${SearchQueryParams.SearchTerm}=${encodeURIComponent(searchTerm)}` : "";
};
